import React from "react";
import { ShieldCheck, Zap, Leaf } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CoreCorporateValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const values = [{
    title: "Safety",
    description: "We prioritize the security of every flight, cargo shipment, and individual through rigorous aviation safety protocols and continuous operational monitoring.",
    icon: <ShieldCheck className="w-12 h-12 text-primary" />
  }, {
    title: "Speed",
    description: "Our ground operations are engineered for rapid turnaround, ensuring that aircraft logistics and cargo timelines are met with absolute precision and urgency.",
    icon: <Zap className="w-12 h-12 text-primary" />
  }, {
    title: "Efficiency",
    description: "Leveraging advanced logistics technology and expert coordination to streamline aircraft handling, catering, and fuel management for peak productivity.",
    icon: <Leaf className="w-12 h-12 text-primary" />
  }];
  return <section data-section-id="3925" id="the-hlc-standard" ref={ref} className={`dark bg-background text-foreground py-24 relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary to-transparent" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary to-transparent" />
        <div className="absolute top-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary to-transparent" />
        <div className="absolute bottom-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary to-transparent" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-primary font-mono text-sm tracking-widest uppercase mb-3">
            Operational Excellence
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 font-sans">
            The HLC Standard
          </h3>
          <p className="text-muted-foreground text-lg leading-relaxed">
            At Handling and Logistic Company, we set the benchmark for aviation ground handling through our core operational pillars, ensuring reliability in every flight.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((item, i) => <div key={i} data-index={i} className="group">
              <Card className="h-full bg-card/40 border-primary/10 backdrop-blur-sm hover:border-primary/40 hover:shadow-[0_0_40px_-10px_rgba(255,191,0,0.2)] transition-all duration-500">
                <CardHeader className="pb-2">
                  <div className="mb-6 inline-flex items-center justify-center w-20 h-20 rounded-sm bg-primary/5 border border-primary/20 shadow-[0_0_30px_-5px_rgba(255,191,0,0.1)] group-hover:shadow-[0_0_40px_-5px_rgba(255,191,0,0.3)] transition-shadow duration-500">
                    {item.icon}
                  </div>
                  <CardTitle className="text-2xl font-bold text-foreground font-sans">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}